/* Scoped adapter for the existing Tabs Studio 5.x integration. */
(function () {
  var selector = '.sigi-pdp-story [data-sigi-pdp-accordions]';

  function enhance(root) {
    var tabs = window.Station && window.Station.Apps && window.Station.Apps.Tabs;
    if (!root || !root.matches(selector) || root.dataset.sigiAccordionsReady ||
        !tabs || typeof tabs.getInstance !== 'function' ||
        typeof tabs.getTab !== 'function' || typeof tabs.setLayout !== 'function' ||
        typeof tabs.close !== 'function') return;

    var instance = tabs.getInstance(root);
    if (!instance || !instance.wrapper || !instance.links.length) return;

    var links = Array.from(instance.links);
    var hash = window.location.hash;
    var hasDeepLink = links.some(function (link) {
      var tab = tabs.getTab(link);
      return tab && (hash === tab.hash || hash === '#' + link.id ||
        hash === '#' + tab.content.id || hash === link.hash);
    });
    var order = ['description', 'benefits', 'directions', 'ingredients', 'faq'];

    order.forEach(function (title) {
      var link = links.find(function (item) {
        return item.textContent.trim().replace(/:$/, '').toLowerCase() === title;
      });
      if (!link) return;
      var tab = tabs.getTab(link);
      if (!tab) return;
      if (title === 'directions') {
        var label = link.querySelector('span');
        if (label) label.textContent = 'How to use';
      }
      instance.wrapper.appendChild(link);
      instance.wrapper.appendChild(tab.content);
    });

    tabs.setLayout({ instance: root, layout: 'vertical' });
    if (!hasDeepLink) links.forEach(function (link) { tabs.close(link); });
    root.dataset.sigiAccordionsReady = 'true';
  }

  document.addEventListener('stationTabsInstanceReady', function (event) {
    enhance(event.detail && event.detail.instance);
  });

  function enhanceExisting() {
    document.querySelectorAll(selector).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceExisting, { once: true });
  } else {
    enhanceExisting();
  }
}());

/* Optional, muted texture videos on the two standard PDPs only. */
(function () {
  var selector = 'body.template-product #MainContent .sigi-pdp-story [data-sigi-pdp-video]';

  function enhanceVideo(video) {
    if (video.dataset.sigiVideoReady || !window.IntersectionObserver || !window.matchMedia) return;
    var button = video.parentElement.querySelector('[data-sigi-video-toggle]');
    if (!button) return;

    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var isFaqVideo = !!video.closest('.sigi-pdp-faq');
    var videoVisible = window.matchMedia(isFaqVideo ? 'all' : '(max-width: 589px), (min-width: 769px)');
    var inView = false;
    var userPaused = false;
    var manualPlay = false;
    var autoBlocked = false;
    var playPending = false;

    function sizeMobileFrame() {
      if (!video.videoWidth || !video.videoHeight) return;
      video.parentElement.style.setProperty('--sigi-video-mobile-ratio',
        video.videoWidth + ' / ' + (video.videoHeight * 0.7));
      var story = video.closest('.sigi-pdp-story');
      if (story && !isFaqVideo) story.style.setProperty('--sigi-video-mobile-ratio',
        video.videoWidth + ' / ' + (video.videoHeight * 0.7));
    }
    video.addEventListener('loadedmetadata', sizeMobileFrame);
    sizeMobileFrame();

    function updateButton() {
      button.textContent = playPending || !video.paused ? 'Pause video' : 'Play video';
    }

    function shouldPlay() {
      return videoVisible.matches && inView && !document.hidden && !userPaused &&
        (manualPlay || (!motion.matches && !autoBlocked));
    }

    function playFailed() {
      playPending = false;
      manualPlay = false;
      autoBlocked = true;
      updateButton();
    }

    function syncPlayback() {
      if (!shouldPlay()) {
        video.pause();
        updateButton();
        return;
      }
      if (!video.paused || playPending) return;
      playPending = true;
      updateButton();
      try {
        var attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(function () {
            playPending = false;
            if (!shouldPlay()) video.pause();
            updateButton();
          }, playFailed);
        } else {
          playPending = false;
          updateButton();
        }
      } catch (error) {
        playFailed();
      }
    }

    button.addEventListener('click', function () {
      userPaused = playPending || !video.paused;
      manualPlay = !userPaused;
      autoBlocked = false;
      syncPlayback();
    });
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);

    var observer = new window.IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (!inView) manualPlay = false;
      syncPlayback();
    }, { threshold: 0 });

    function motionChanged() {
      manualPlay = false;
      syncPlayback();
    }
    if (motion.addEventListener) motion.addEventListener('change', motionChanged);
    else if (motion.addListener) motion.addListener(motionChanged);

    function viewportChanged() {
      if (!videoVisible.matches) manualPlay = false;
      syncPlayback();
    }
    if (videoVisible.addEventListener) videoVisible.addEventListener('change', viewportChanged);
    else if (videoVisible.addListener) videoVisible.addListener(viewportChanged);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) manualPlay = false;
      syncPlayback();
    });

    video.muted = true;
    video.loop = true;
    observer.observe(video);
    video.controls = false;
    button.hidden = false;
    video.dataset.sigiVideoReady = 'true';
    updateButton();
  }

  function enhanceVideos() {
    document.querySelectorAll(selector).forEach(enhanceVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceVideos, { once: true });
  } else {
    enhanceVideos();
  }
}());

/* Split MG's existing FAQ into native accordions; retain the fallback if its format changes. */
(function () {
  function enhanceFaq(source) {
    var body = source.querySelector('.sigi-pdp-faq-answer');
    if (!body) return;
    var groups = [];
    var current;
    var unexpected = false;
    Array.from(body.childNodes).forEach(function (node) {
      var question = node.nodeType === 1 && node.tagName === 'P' &&
        /\?$/.test(node.textContent.trim()) && !node.querySelector('a, button, input');
      if (question) {
        current = { question: node, answer: [] };
        groups.push(current);
      } else if (current) {
        current.answer.push(node);
      } else if (node.nodeType === 1 || node.textContent.trim()) {
        unexpected = true;
      }
    });
    if (unexpected || !groups.length || groups.some(function (group) {
      return !group.answer.some(function (node) {
        return node.textContent.trim() && !(node.nodeType === 1 &&
          node.querySelector('.showmore-a, .showless-a'));
      });
    })) return;

    var fragment = document.createDocumentFragment();
    groups.forEach(function (group) {
      var item = document.createElement('details');
      var summary = document.createElement('summary');
      var answer = document.createElement('div');
      item.className = 'sigi-pdp-faq-item';
      answer.className = 'sigi-pdp-faq-answer';
      while (group.question.firstChild) summary.appendChild(group.question.firstChild);
      group.answer.forEach(function (node) { answer.appendChild(node); });
      item.appendChild(summary);
      item.appendChild(answer);
      fragment.appendChild(item);
    });
    source.replaceWith(fragment);
  }

  function enhanceFaqs() {
    document.querySelectorAll('body.template-product #MainContent .sigi-pdp-story [data-sigi-faq-source]').forEach(enhanceFaq);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceFaqs, { once: true });
  } else {
    enhanceFaqs();
  }
}());
